import { Field } from 'redux-form'
import uniqueId from 'lodash-es/uniqueId'
import Label from './Label'
import { truncateLongNames } from '../../../utils/common'
import { AddRequiredValidation } from '..'

export class renderSelect extends Component {
  constructor(props) {
    super(props)
    this.state = { focusClass: '' }
  }

  onFocusHandler(e) {
    this.setState({ focusClass: 'focus' })
    this.props.input.onFocus && this.props.input.onFocus(e)
  }

  onBlurHandler(e) {
    this.setState({ focusClass: '' })
    this.props.input.onBlur && this.props.input.onBlur(e)
  }

  render() {
    const {
      label,
      options,
      input,
      labelledBy,
      disabled,
      meta,
      truncate,
      showEmptyOption = true,
      autoFocus = false,
      style = {},
    } = this.props
    const { error, touched, active } = meta || {}
    const { value = '', label: visibleLabel } =
      options.find(({ value }) => value === input.value) || {}
    const hasError = error && touched
    const errorId = `${input.name}-error`
    const blankLabel = label ? `Choose a ${label.toLowerCase()}` : 'Choose...'

    return (
      <div className={`form-group ${hasError ? 'has-error' : ''}`} style={style}>
        {label ? <Label {...this.props} name={input.name} /> : null}
        <div className="cb-select-container">
          <select
            {...input}
            id={input.name}
            name={input.name}
            className="form-control replaced"
            disabled={disabled}
            aria-labelledby={labelledBy}
            aria-describedby={hasError ? errorId : null}
            value={value}
            onFocus={this.onFocusHandler.bind(this)}
            onBlur={this.onBlurHandler.bind(this)}
            autoFocus={autoFocus}
          >
            {showEmptyOption ? <option value="">{blankLabel}</option> : null}
            {options.map(c => (
              <option value={c.value} key={uniqueId()}>
                {c.label}
              </option>
            ))}
          </select>
          <span
            className={`cb-select ${this.state.focusClass} ${disabled ? 'disabled' : ''}`}
            aria-hidden={disabled}
          >
            <span>
              <span>
                <i className="cb-select-arrow" />
                {visibleLabel ? truncateLongNames(visibleLabel, truncate) : blankLabel}
              </span>
            </span>
          </span>
        </div>
        {hasError ? (
          <p tabIndex="-1" id={errorId} className="cb-error-msg" role="alert">
            {error}
          </p>
        ) : null}
      </div>
    )
  }
}

export default props => (
  <Field
    {...props}
    component={renderSelect}
    validate={AddRequiredValidation(props.isRequired, props.validate)}
    normalize={props.normalize}
  />
)
